import tw from 'tailwind-styled-components'

export const TwStickerEditState = tw.div`
  relative
  z-10
  py-4
  px-6
  border-solid
  border-0
  border-b-1
  border-obscure-old
`

export const TwStickerItemState = tw.div`
  flex
  relative
  group
  px-12
  hover:bg-background-active
`

export const TwStickerItemStateSticker = tw.div`
  flex
  py-4
  align-center
  w-full
  justify-between
  cursor-pointer
`

export const TwStickerItemActions = tw.div`
  flex
  gap-8
  hidden
  group-hover:flex
  items-center
  text-normal-gray
`

export const TwStickerItemStateCheckbox = tw.div`
  flex
  items-center
  pl-8
`

export const TwStickerMenuBody = tw.div`
  overflow-auto
`
